export default "__VITE_ASSET__27145af4__"